export const titleTranslation = {
    en: "Services",
    he: "שירות",
    ar: "الخدمات",
};

export const offersTranslation = {
    mainTitle: {
        en: "Services I Offer",
        he: "שירותים שאני מציע",
        ar: "الخدمات التي أقدمها",
    },
    offers: [
        {
            icon: "code-slash",
            text: {
                en: "Web Development",
                he: "פיתוח אתרים",
                ar: "تطوير مواقع الكترونية",
            }
        },
        {
            icon: "brush",
            text: {
                en: "Web Design",
                he: "עיצוב אתרים",
                ar: "تصميم مواقع الكترونية",
            }
        },
    ],
};

export const whyMeTranslation = {
    mainTitle: {
        en: "Why Me?",
        he: "למה אני?",
        ar: "لماذا أنا؟",
    },
    content: [
        {
            title: {
                en: "Fast Performance",
                he: "ביצועים מהירים",
                ar: "أداء سريع",
            },
            text: {
                en: "I optimize website performance for fast loading and seamless user experience.",
                he: "אני ממקד את הקפדה על ביצועים מהירים וחוויית משתמש חלקה לאתרים שאני מפתח.",
                ar: "أنا ملتزم بتحسين أداء الموقع لتحميل سريع وتجربة مستخدم سلسة.",
            },
            icon: "speedometer-outline",
        },
        {
            title: {
                en: "Responsive Design",
                he: "עיצוב רספונסיבי",
                ar: "تصميم متجاوب",
            },
            text: {
                en: "Responsive designs that adapt to any screen size for easy access on all devices.",
                he: "עיצובים רספונסיביים שמתאימים לכל גודל מסך כדי לאפשר גישה קלה בכל מכשיר.",
                ar: "تصميمًا استجابيًا يتكيف مع أي حجم شاشة لسهولة الوصول على جميع الأجهزة.",
            },
            icon: "expand-outline",
        },
        {
            title: {
                en: "Well-Structured Code",
                he: "קוד מובנה היטב",
                ar: "كود جيد التنظيم",
            },
            text: {
                en: "Easy-to-understand code for smooth website operation and future scalability.",
                he: "קוד נקי וברור כדי להבטיח פעולה חלקה וניהול פשוט בעתיד.",
                ar: " أكوادًا نظيفة وواضحة لتشغيل الموقع بسلاسة وسهولة الإدارة في المستقبل.",
            },
            icon: "file-tray-full-outline",
        },
        {
            title: {
                en: "User Friendly Design",
                he: "עיצוב ידידותי למשתמש",
                ar: "تصميم سهل الاستخدام",
            },
            text: {
                en: "I design aesthetically pleasing and easy-to-navigate websites for positive user experiences.",
                he: "אני מעצב עיצובים נעימים לעין וקלים לניווט כדי להבטיח חוויית משתמש חיובית.",
                ar: "أقوم بتصميم مواقع ويب ممتعة من الناحية الجمالية وسهلة التصفح لتجربة مستخدم إيجابية.",
            },
            icon: "body-outline",
        },
        {
            title: {
                en: "Affordable Prices",
                he: "מחירים נוחים",
                ar: "أسعار مقبولة",
            },
            text: {
                en: "I offer competitive and affordable pricing for high-quality web development services.",
                he: "אני מציע מחירים תחרותיים וסבירים עבור שירותי פיתוח אתרים באיכות גבוהה.",
                ar: "أقدم أسعارًا تنافسية ومعقولة لخدمات تطوير ويب عالية الجودة.",
            },
            icon: "cash-outline",
        },
    ],
};
